<template>
  <nav class="app-breadcrumb" aria-label="Percorso di navigazione">
    <div class="app-breadcrumb-inner">
      <router-link class="breadcrumb-home" :to="{ name: 'HomePage' }">
        Home
      </router-link>
      <i
        class="fa-solid fa-chevron-right breadcrumb-separator"
        aria-hidden="true"
      ></i>
      <span class="breadcrumb-current" aria-current="page">
        {{ currentLabel }}
      </span>
    </div>
  </nav>
</template>

<script>
export default {
  name: "AppBreadcrumb",
  computed: {
    currentLabel() {
      return this.$route.meta.breadcrumb || this.$route.name || "";
    },
  },
};
</script>

<style scoped>
.app-breadcrumb {
  display: flex;
  width: 100%;
  min-height: var(--app-breadcrumb-height, 2.35rem);
  flex: 0 0 var(--app-breadcrumb-height, 2.35rem);
  align-items: center;
  box-sizing: border-box;
  padding: 0.42rem clamp(1rem, 3vw, 2.75rem);
  border-bottom: 0;
  background: transparent;
  color: #216951;
  text-align: left;
}

.app-breadcrumb-inner {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.84rem;
  font-weight: 650;
  line-height: 1.25;
  transform: translateY(0.18rem);
}

.breadcrumb-home {
  color: #216951;
  font-weight: 650;
  text-decoration: none;
  transition: color 0.16s ease;
}

.breadcrumb-home:hover {
  color: #154c39;
  text-decoration: underline;
  text-underline-offset: 0.16rem;
}

.breadcrumb-separator {
  color: #91a39b;
  font-size: 0.52rem;
}

.breadcrumb-current {
  min-width: 0;
  overflow: hidden;
  color: #39735f;
  cursor: pointer;
  text-overflow: ellipsis;
  white-space: nowrap;
  transition: color 0.16s ease;
}

.breadcrumb-current:hover {
  color: #154c39;
  text-decoration: underline;
  text-underline-offset: 0.16rem;
}
</style>
